import packingListTemplate from "./packingListTemplate";
import orderItemLabelTemplate from "./orderItemLabelTemplate";
import shippingAddress from "./shippingAddress";
import orderLogisticsWarning from "./orderLogisticsWarning";
import shippingCost from "./shippingCost";
import packWeight from "./packWeight";
import shippingArea from "./shippingArea";
import product from "./product";
import ewaybillAccount from "./ewaybillAccount";
import waybillTemplate from "./waybillTemplate";
import autoRate from "./autoRate";
import user from "../user";

export default {
    packingListTemplate,
    orderItemLabelTemplate,
    shippingAddress,
    orderLogisticsWarning,
    shippingCost,
    packWeight,
    shippingArea,
    product,
    ewaybillAccount,
    waybillTemplate,
    autoRate,
    user,
};

export {
    packingListTemplate,
    orderItemLabelTemplate,
    shippingAddress,
    orderLogisticsWarning,
    shippingCost,
    packWeight,
    shippingArea,
    product,
    ewaybillAccount,
    waybillTemplate,
    autoRate,
    user,
};
